import React, { useState, useEffect } from 'react';
import { db, auth, googleProvider } from '../firebaseConfig';
import { collection, getDocs, query, where, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { signInWithPopup } from 'firebase/auth';
import { turkeyCities } from '../data/turkeyCities';
import Logo from '../components/Logo';

const AdminLogin = () => {
    const [step, setStep] = useState('email'); // 'email' | 'otp' | 'setup' | 'password'
    const [email, setEmail] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const session = localStorage.getItem('sahalive_session');
        if (session) {
            try {
                const parsed = JSON.parse(session);
                // Oturum 7 gün boyunca geçerli olsun
                if (Date.now() - parsed.timestamp < 7 * 24 * 60 * 60 * 1000) {
                    window.location.href = "/admin-dashboard";
                } else {
                    localStorage.removeItem('sahalive_session');
                }
            } catch (e) {
                localStorage.removeItem('sahalive_session');
            }
        }
    }, []);
    
    // Geçici değişkenler
    const [tempUserData, setTempUserData] = useState(null);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    
    // YENİ: Tesis Detayları
    const [city, setCity] = useState("");
    const [district, setDistrict] = useState("");
    const [openTime, setOpenTime] = useState("09:00");
    const [closeTime, setCloseTime] = useState("24:00");
    const [imageUrl, setImageUrl] = useState("");
    const [amenities, setAmenities] = useState({
        dus: false,
        otopark: false,
        kantin: false,
        krampon: false,
        eldiven: false,
        servis: false
    });

    // BAŞVURU FORMU DURUMLARI
    const [applyFieldName, setApplyFieldName] = useState("");
    const [applyName, setApplyName] = useState("");
    const [applySurname, setApplySurname] = useState("");
    const [applyEmail, setApplyEmail] = useState("");
    const [applyPhone, setApplyPhone] = useState("");
    const [applyCity, setApplyCity] = useState("");
    const [applyDistrict, setApplyDistrict] = useState("");

    const superAdmins = [
        "suerdemahmetsami7@gmail.com", 
        "yagizmuhammed47@gmail.com",
        "sahaliveproje@gmail.com",
        "admin@sahalive.com"
    ];

    // YENİ: Hızlı Saha Başvurusu Gönderimi
    const handleApply = async (e) => {
        e.preventDefault();
        const safeEmail = applyEmail.trim().toLowerCase();
        const phoneClean = applyPhone.replace(/\s/g, '');

        if (!applyFieldName || !applyName || !applySurname || !safeEmail || !phoneClean || !applyCity || !applyDistrict) {
            alert("Lütfen tüm alanları eksiksiz doldurunuz.");
            return;
        }

        if (!/^05[0-9]{9}$/.test(phoneClean)) {
            alert("Lütfen geçerli bir telefon numarası giriniz (Örn: 05xx xxx xx xx).");
            return;
        }

        setIsProcessing(true);
        try {
            // E-posta kontrolü
            const q = query(collection(db, "tesisler"), where("email", "==", safeEmail));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                alert("Bu e-posta adresi ile zaten bir saha başvurusu veya kaydı bulunuyor!");
                setIsProcessing(false);
                return;
            }

            // Yeni saha başvurusu oluştur (pending durumunda)
            const newSahaRef = doc(collection(db, "tesisler"));
            await setDoc(newSahaRef, {
                fieldName: applyFieldName.trim(),
                email: safeEmail,
                name: applyName.trim(),
                surname: applySurname.trim(),
                phone: applyPhone.trim(),
                city: applyCity,
                district: applyDistrict,
                status: "pending",
                createdAt: serverTimestamp(),
                username: "",
                password: ""
            });

            alert("Harika! Saha başvurunuz başarıyla alındı. 🎉\nSüper Admin onayından sonra e-posta adresiniz ile giriş yapıp kurulumunuzu tamamlayabilirsiniz.");
            
            // Alanları sıfırla ve giriş ekranına dön
            setApplyFieldName("");
            setApplyName("");
            setApplySurname("");
            setApplyEmail("");
            setApplyPhone("");
            setApplyCity("");
            setApplyDistrict("");
            setStep('email');
        } catch (err) {
            alert("Başvuru sırasında hata oluştu: " + err.message);
        } finally {
            setIsProcessing(false);
        }
    };

    // Google ile Giriş Mantığı (Saha Sahipleri ve Süper Admin için)
    const handleGoogleLogin = async () => {
        setIsProcessing(true);
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;
            const safeEmail = user.email.trim().toLowerCase();

            // 1. Süper Admin Kontrolü
            const isSuperAdmin = superAdmins.includes(safeEmail);
            if (isSuperAdmin) {
                localStorage.setItem("superAdmin", "true");
                alert("Hoş geldiniz, Süper Admin Girişi Başarılı!");
                window.location.href = "/superadmin";
                return;
            }

            // 2. Tesis Sahibi Kontrolü
            const q = query(collection(db, "tesisler"), where("email", "==", safeEmail));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                const foundTesis = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
                
                // Durum kontrolü
                if (foundTesis.status === "pending") {
                    alert("Saha başvurunuz Süper Admin onayındadır. Onaylanmadan giriş yapılamaz.");
                    setIsProcessing(false);
                    return;
                }

                // Oturum açma
                localStorage.setItem('sahalive_session', JSON.stringify({ userId: foundTesis.id, user: foundTesis, timestamp: Date.now() }));
                
                // Eğer kurulum tamamlanmadıysa (username/password yoksa) direkt setup'a at
                if (!foundTesis.username || !foundTesis.password) {
                    setTempUserData(foundTesis);
                    setStep('setup');
                    alert("İlk girişiniz! Kurulum sihirbazına yönlendiriliyorsunuz.");
                } else {
                    alert("Giriş Başarılı!");
                    window.location.href = "/admin-dashboard";
                }
            } else {
                alert("Bu Google hesabı ile kayıtlı bir halı saha bulunamadı. Lütfen önce başvuru yapın.");
            }
        } catch (error) {
            console.error("Admin Google Login Error:", error);
            alert("Google ile giriş yapılamadı: " + error.message);
        } finally {
            setIsProcessing(false);
        }
    };

    // DOĞRUDAN PANEL GİRİŞİ (Çift doğrulama / OTP olmadan)
    const handleDirectAdminLogin = async (e) => {
        e.preventDefault();
        const safeInput = email.trim().toLowerCase();
        if (!safeInput || !password) {
            alert("Lütfen kullanıcı adı / e-posta ve şifrenizi giriniz.");
            return;
        }

        setIsProcessing(true);
        try {
            // 1. Süper Admin Kontrolü
            const isSuperAdmin = superAdmins.includes(safeInput) || safeInput === 'sami' || safeInput === 'suerdemahmetsami7@gmail.com';
            if (isSuperAdmin) {
                if (password === 'Ahmet19o7!..') {
                    localStorage.setItem("superAdmin", "true");
                    alert("Hoş geldiniz, Süper Admin Girişi Başarılı!");
                    window.location.href = "/superadmin";
                    return;
                } else {
                    alert("Hatalı Süper Admin şifresi!");
                    setIsProcessing(false);
                    return;
                }
            }

            // 2. Tesis Sahibi Kontrolü (Firestore)
            let q = query(collection(db, "tesisler"), where("username", "==", safeInput));
            let querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                q = query(collection(db, "tesisler"), where("email", "==", safeInput));
                querySnapshot = await getDocs(q);
            }

            if (!querySnapshot.empty) {
                const foundTesis = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };

                // Onay durumu kontrolü
                if (foundTesis.status === "pending") {
                    alert("Saha başvurunuz Süper Admin onayındadır. Onaylanmadan giriş yapılamaz.");
                    setIsProcessing(false);
                    return;
                }

                // Eğer kullanıcı adı veya şifre belirlenmemişse kurulum sihirbazına gönder
                if (!foundTesis.username || !foundTesis.password) {
                    setTempUserData(foundTesis);
                    setStep('setup');
                    alert("İlk girişiniz! Kurulum sihirbazına yönlendiriliyorsunuz.");
                    setIsProcessing(false);
                    return;
                }

                // Şifre kontrolü
                if (foundTesis.password === password) {
                    localStorage.setItem('sahalive_session', JSON.stringify({ userId: foundTesis.id, user: foundTesis, timestamp: Date.now() }));
                    alert("Giriş Başarılı!");
                    window.location.href = "/admin-dashboard";
                    return;
                } else {
                    alert("Hatalı şifre!");
                    setIsProcessing(false);
                    return;
                }
            }

            alert("Bu kullanıcı adı veya e-posta ile kayıtlı bir yetkili/tesis bulunamadı.");
        } catch (error) {
            console.error(error);
            alert("Giriş sırasında hata oluştu: " + error.message);
        } finally {
            setIsProcessing(false);
        }
    };


    const handleCredentialSetup = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) return alert("Şifreler eşleşmiyor!");
        if (password.length < 6) return alert("Şifre en az 6 karakter olmalıdır!");
        if (!username) return alert("Lütfen bir kullanıcı adı belirleyin!");
        if (!city || !district) return alert("Lütfen şehir ve ilçe bilgilerini giriniz!");

        setLoading(true);
        try {
            const fieldRef = doc(db, "tesisler", tempUserData.id);
            await setDoc(fieldRef, {
                username: username.toLowerCase(),
                password: password,
                city: city,
                district: district,
                openTime: openTime,
                closeTime: closeTime,
                imageUrl: imageUrl,
                amenities: amenities,
                status: "approved", // Kurulum tamamlandığı için artık tam aktif
                updatedAt: serverTimestamp()
            }, { merge: true });
            
            alert("Tesis kurulumu başarıyla tamamlandı! Giriş yapabilirsiniz.");
            setStep('email');
            setEmail("");
            setUsername("");
            setPassword("");
        } catch (err) {
            alert("Hata: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleImageUpload = () => {
        const widget = window.cloudinary.createUploadWidget(
            { 
                cloudName: 'dpx6vshoa', 
                uploadPreset: 'sahalive_preset',
                sources: ['local'], // Sadece dosyalar (en sade hali)
                multiple: false,
                clientAllowedFormats: ["png", "jpg", "jpeg", "webp"],
                maxFileSize: 5000000,
                styles: {
                    palette: {
                        window: "#FFFFFF",
                        windowBorder: "#90A0B3",
                        tabIcon: "#0078FF",
                        menuIcons: "#5A616A",
                        textDark: "#000000",
                        textLight: "#FFFFFF",
                        link: "#0078FF",
                        action: "#FF620C",
                        inactiveTabIcon: "#0E2F5A",
                        error: "#F44235",
                        inProgress: "#0078FF",
                        complete: "#20B832",
                        sourceBg: "#E4EBF1"
                    }
                }
            },
            (error, result) => {
                if (!error && result && result.event === "success") {
                    setImageUrl(result.info.secure_url);
                    alert("Fotoğraf başarıyla yüklendi!");
                }
            }
        );
        widget.open();
    };

    const handleAmenityChange = (key) => {
        setAmenities(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const handlePasswordLogin = (e) => {
        e.preventDefault();
        if (username.toLowerCase() === tempUserData.username && password === tempUserData.password) {
            localStorage.setItem('sahalive_session', JSON.stringify({ userId: tempUserData.id, user: tempUserData, timestamp: Date.now() }));
            window.location.href = "/admin-dashboard";
        } else {
            setErrorMessage("Kullanıcı adı veya şifre hatalı!");
        }
    };

    const [errorMessage, setErrorMessage] = useState('');

    return (
        <div className="d-flex justify-content-center align-items-center bg-dark" style={{ minHeight: "100dvh", padding: "20px" }}>
            
            {step === 'setup' ? (
                /* KURULUM ADIMI: DAHA GENİŞ VE DÜZENLİ KONTEYNER */
                <div className="setup-wrapper animate__animated animate__fadeIn" style={{ maxWidth: '900px', width: '100%', zIndex: 10 }}>
                    <div className="text-center mb-4">
                        <Logo width="240px" lightText={true} />
                    </div>
                    
                    <div className="card shadow-2xl border-0 rounded-5 overflow-hidden">
                        <div className="bg-warning p-4 p-md-5 text-center">
                            <h2 className="fw-bold mb-1 text-dark">Hoş Geldiniz! 🚀</h2>
                            <p className="mb-0 text-dark opacity-75 fw-medium">Tesisinizi birkaç adımda sisteme hazır hale getirelim.</p>
                        </div>
                        
                        <div className="card-body p-4 p-md-5 bg-white">
                            <form onSubmit={handleCredentialSetup}>
                                <div className="row g-4">
                                    
                                    {/* BÖLÜM 1: GİRİŞ BİLGİLERİ */}
                                    <div className="col-12">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="bg-warning bg-opacity-10 p-2 rounded-3 me-3">
                                                <i className="fas fa-user-lock text-warning fs-5"></i>
                                            </div>
                                            <h5 className="fw-bold m-0 text-dark text-uppercase letter-spacing-1">Panel Giriş Bilgileri</h5>
                                        </div>
                                        <div className="row g-3 p-3 bg-light rounded-4">
                                            <div className="col-md-12">
                                                <label className="form-label small fw-bold text-muted">Kullanıcı Adı</label>
                                                <input type="text" className="form-control form-control-lg border-0 shadow-sm" placeholder="Örn: sampiyonsaha" value={username} onChange={e => setUsername(e.target.value)} required />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label small fw-bold text-muted">Şifre</label>
                                                <input type="password" className="form-control form-control-lg border-0 shadow-sm" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label small fw-bold text-muted">Şifre Tekrar</label>
                                                <input type="password" className="form-control form-control-lg border-0 shadow-sm" placeholder="••••••••" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
                                            </div>
                                        </div>
                                    </div>

                                    {/* BÖLÜM 2: LOKASYON & ZAMAN */}
                                    <div className="col-12 mt-5">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="bg-primary bg-opacity-10 p-2 rounded-3 me-3">
                                                <i className="fas fa-map-marked-alt text-primary fs-5"></i>
                                            </div>
                                            <h5 className="fw-bold m-0 text-dark text-uppercase letter-spacing-1">Tesis & Çalışma Detayları</h5>
                                        </div>
                                        <div className="row g-3 p-3 bg-light rounded-4">
                                            <div className="col-md-6">
                                                <label className="small fw-bold mb-1 text-muted">Şehir Seçiniz</label>
                                                <select 
                                                    className="form-select border-0 shadow-sm p-3 bg-light rounded-3" 
                                                    value={city} 
                                                    onChange={e => { setCity(e.target.value); setDistrict(""); }} 
                                                    required
                                                >
                                                    <option value="">Şehir Seçin</option>
                                                    {Object.keys(turkeyCities).sort().map(c => <option key={c} value={c}>{c}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="small fw-bold mb-1 text-muted">İlçe Seçiniz</label>
                                                <select 
                                                    className="form-select border-0 shadow-sm p-3 bg-light rounded-3" 
                                                    value={district} 
                                                    onChange={e => setDistrict(e.target.value)} 
                                                    disabled={!city}
                                                    required
                                                >
                                                    <option value="">{city ? "İlçe Seçin" : "Önce Şehir Seçin"}</option>
                                                    {city && turkeyCities[city].sort().map(d => <option key={d} value={d}>{d}</option>)}
                                                </select>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label small fw-bold text-muted">Açılış Saati</label>
                                                <input type="time" className="form-control border-0 shadow-sm p-2" value={openTime} onChange={e => setOpenTime(e.target.value)} required />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label small fw-bold text-muted">Kapanış Saati</label>
                                                <input type="time" className="form-control border-0 shadow-sm p-2" value={closeTime} onChange={e => setCloseTime(e.target.value)} required />
                                            </div>
                                        </div>
                                    </div>

                                    {/* BÖLÜM 3: İMKANLAR (Responsive Grid) */}
                                    <div className="col-12 mt-5">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="bg-success bg-opacity-10 p-2 rounded-3 me-3">
                                                <i className="fas fa-star text-success fs-5"></i>
                                            </div>
                                            <h5 className="fw-bold m-0 text-dark text-uppercase letter-spacing-1">Tesis İmkânları</h5>
                                        </div>
                                        <div className="row g-2 g-md-3">
                                            {[
                                                { key: 'dus', label: 'Duş (Sıcak Su)', icon: '🚿' },
                                                { key: 'otopark', label: 'Ücretsiz Otopark', icon: '🅿️' },
                                                { key: 'kantin', label: 'Kantin / Kafe', icon: '☕' },
                                                { key: 'krampon', label: 'Krampon Kiralama', icon: '👟' },
                                                { key: 'eldiven', label: 'Eldiven Kiralama', icon: '🧤' },
                                                { key: 'servis', label: 'Servis Hizmeti', icon: '🚐' }
                                            ].map(item => (
                                                <div key={item.key} className="col-6 col-md-4">
                                                    <div 
                                                        onClick={() => handleAmenityChange(item.key)}
                                                        className={`p-3 rounded-4 border-2 transition-all d-flex flex-column align-items-center justify-content-center text-center h-100 ${amenities[item.key] ? 'border-success bg-success bg-opacity-10 text-success' : 'border-light bg-light text-muted'}`}
                                                        style={{ cursor: 'pointer', transition: '0.3s' }}
                                                    >
                                                        <span className="fs-3 mb-2">{item.icon}</span>
                                                        <span className="small fw-bold">{item.label}</span>
                                                        {amenities[item.key] && <i className="fas fa-check-circle position-absolute top-0 end-0 m-2 mt-3 me-3"></i>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* BÖLÜM 4: FOTOĞRAF */}
                                    <div className="col-12 mt-5">
                                        <div className="border-dashed-2 rounded-5 p-4 bg-light text-center" style={{ border: '2px dashed #ddd' }}>
                                            {imageUrl ? (
                                                <div className="position-relative d-inline-block">
                                                    <img src={imageUrl} alt="Saha" style={{ width: '100%', maxWidth: '400px', height: '220px', objectFit: 'cover', borderRadius: '24px' }} className="shadow" />
                                                    <button type="button" className="btn btn-dark btn-sm rounded-pill position-absolute top-0 end-0 m-3" onClick={handleImageUpload}><i className="fas fa-edit"></i></button>
                                                </div>
                                            ) : (
                                                <div className="py-5" onClick={handleImageUpload} style={{ cursor: 'pointer' }}>
                                                    <div className="bg-white shadow-sm d-inline-flex p-4 rounded-circle mb-3">
                                                        <i className="fas fa-cloud-upload-alt text-muted display-5"></i>
                                                    </div>
                                                    <h6 className="fw-bold text-dark">Saha Fotoğrafı Yükle</h6>
                                                    <p className="text-muted small mb-0 px-4">Rezervasyon listesinde görünecek en güzel görseli seçin.</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* SUBMIT */}
                                    <div className="col-12 mt-5">
                                        <button type="submit" className="btn btn-dark btn-lg w-100 py-3 rounded-4 fw-bold shadow-lg transition-all hover-up" disabled={loading}>
                                            {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : <i className="fas fa-check-double me-2"></i>}
                                            {loading ? "İŞLENİYOR..." : "KURULUMU TAMAMLA VE PANELİNE GİT"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            ) : (
                /* GİRİŞ & OTP ADIMLARI: DAR VE ODAKLI KONTEYNER */
                <div className="bg-black p-4 p-md-5 rounded-5 text-center border border-secondary shadow-lg animate__animated animate__fadeIn" style={{ maxWidth: "450px", width: "100%", zIndex: 10 }}>
                    <div className="mb-4 d-flex justify-content-center">
                        <Logo width="240px" lightText={true} />
                    </div>

                    {step === 'email' ? (
                        <div className="animate__animated animate__fadeIn">
                            <h4 className="text-white mb-2 fw-bold">Yönetici Paneli Girişi</h4>
                            <p className="text-secondary small mb-4">Saha yöneticisi veya Süper Admin girişi</p>
                            
                            <form onSubmit={handleDirectAdminLogin}>
                                <div className="mb-3 text-start">
                                    <label className="text-light small fw-bold ms-2 mb-2">Kullanıcı Adı veya E-Posta</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-lg bg-dark text-white border-secondary shadow-none" 
                                        placeholder="Kullanıcı adı veya e-posta" 
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        autoFocus
                                        required
                                    />
                                </div>
                                <div className="mb-4 text-start">
                                    <label className="text-light small fw-bold ms-2 mb-2">Şifre</label>
                                    <input 
                                        type="password" 
                                        className="form-control form-control-lg bg-dark text-white border-secondary shadow-none" 
                                        placeholder="••••••••" 
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <button 
                                    type="submit" 
                                    className="btn btn-warning btn-lg w-100 fw-bold shadow position-relative mb-2" 
                                    disabled={isProcessing}
                                    style={{ borderRadius: "12px", border: "2px solid #CCA000" }}
                                >
                                    {isProcessing ? <span>Giriş Yapılıyor...</span> : <span>GİRİŞ YAP <i className="fas fa-sign-in-alt ms-2"></i></span>}
                                </button>
                            </form>
                            <div className="d-flex align-items-center my-3 text-muted">
                                <hr className="flex-grow-1 border-secondary m-0" />
                                <span className="mx-2 small">veya</span>
                                <hr className="flex-grow-1 border-secondary m-0" />
                            </div>
                            <button 
                                type="button"
                                onClick={handleGoogleLogin}
                                className="btn btn-outline-light btn-lg w-100 fw-bold d-flex align-items-center justify-content-center gap-2 shadow-sm mb-3"
                                disabled={isProcessing}
                                style={{ borderRadius: "12px", border: "1px solid #444", fontSize: "15px" }}
                            >
                                <img src="https://img.icons8.com/color/16/000000/google-logo.png" alt="Google" />
                                Google ile Giriş Yap
                            </button>
                            <div className="mt-4 pt-3 border-top border-secondary text-muted small">
                                Halı sahanız mı var? <span onClick={() => setStep('apply')} className="text-warning fw-bold text-decoration-none ms-1" style={{ cursor: 'pointer' }}>Sahanı Kaydet</span>
                            </div>
                        </div>
                    ) : step === 'apply' ? (
                        <div className="animate__animated animate__fadeIn text-start text-white">
                            <h4 className="text-white text-center mb-2 fw-bold">Yeni Tesis Başvurusu</h4>
                            <p className="text-secondary text-center small mb-4">SahaLive ailesine katılmak için bilgilerinizi giriniz.</p>
                            
                            <form onSubmit={handleApply}>
                                <div className="mb-3">
                                    <label className="text-light small fw-bold mb-1">Halı Saha Adı</label>
                                    <input type="text" className="form-control bg-dark text-white border-secondary shadow-none" placeholder="Örn: Şampiyon Halı Saha" value={applyFieldName} onChange={e => setApplyFieldName(e.target.value)} required />
                                </div>
                                <div className="row g-2 mb-3">
                                    <div className="col-6">
                                        <label className="text-light small fw-bold mb-1">Yetkili Adı</label>
                                        <input type="text" className="form-control bg-dark text-white border-secondary shadow-none" placeholder="Ad" value={applyName} onChange={e => setApplyName(e.target.value)} required />
                                    </div>
                                    <div className="col-6">
                                        <label className="text-light small fw-bold mb-1">Yetkili Soyadı</label>
                                        <input type="text" className="form-control bg-dark text-white border-secondary shadow-none" placeholder="Soyad" value={applySurname} onChange={e => setApplySurname(e.target.value)} required />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className="text-light small fw-bold mb-1">E-Posta Adresi</label>
                                    <input type="email" className="form-control bg-dark text-white border-secondary shadow-none" placeholder="iletisim@sahaniz.com" value={applyEmail} onChange={e => setApplyEmail(e.target.value)} required />
                                </div>
                                <div className="mb-3">
                                    <label className="text-light small fw-bold mb-1">Telefon Numarası</label>
                                    <input type="tel" className="form-control bg-dark text-white border-secondary shadow-none" placeholder="05xx xxx xx xx" value={applyPhone} onChange={e => setApplyPhone(e.target.value)} required />
                                </div>
                                <div className="row g-2 mb-4">
                                    <div className="col-6">
                                        <label className="text-light small fw-bold mb-1">Şehir</label>
                                        <select className="form-select bg-dark text-white border-secondary shadow-none" value={applyCity} onChange={e => { setApplyCity(e.target.value); setApplyDistrict(""); }} required>
                                            <option value="">Seçiniz</option>
                                            {Object.keys(turkeyCities).sort().map(c => <option key={c} value={c}>{c}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-6">
                                        <label className="text-light small fw-bold mb-1">İlçe</label>
                                        <select className="form-select bg-dark text-white border-secondary shadow-none" value={applyDistrict} onChange={e => setApplyDistrict(e.target.value)} disabled={!applyCity} required>
                                            <option value="">Seçiniz</option>
                                            {applyCity && turkeyCities[applyCity].sort().map(d => <option key={d} value={d}>{d}</option>)}
                                        </select>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-warning btn-lg w-100 fw-bold shadow mb-3" disabled={isProcessing} style={{ borderRadius: "12px", border: "2px solid #CCA000" }}>
                                    {isProcessing ? "Gönderiliyor..." : "BAŞVURUYU GÖNDER"}
                                </button>
                                <button type="button" className="btn btn-outline-light w-100 fw-bold" onClick={() => setStep('email')} style={{ borderRadius: "12px" }}>
                                    Geri Dön
                                </button>
                            </form>
                        </div>

                    ) : (
                        <div className="animate__animated animate__fadeIn">
                            <h4 className="text-white mb-2 fw-bold">Panel Girişi</h4>
                            <p className="text-secondary small mb-4">Saha paneline girmek için şifrenizi giriniz.</p>
                            <form onSubmit={handlePasswordLogin}>
                                <div className="mb-3 text-start">
                                    <label className="text-light small fw-bold ms-2 mb-2">Kullanıcı Adı</label>
                                    <input className="form-control bg-dark text-white border-secondary" value={username} onChange={e => setUsername(e.target.value)} required />
                                </div>
                                <div className="mb-4 text-start">
                                    <label className="text-light small fw-bold ms-2 mb-2">Şifre</label>
                                    <input type="password" className="form-control bg-dark text-white border-secondary" value={password} onChange={e => setPassword(e.target.value)} required />
                                </div>
                                {errorMessage && <div className="text-danger small mb-3">{errorMessage}</div>}
                                <button className="btn btn-warning w-100 fw-bold py-3">PANELİNE GİRİŞ YAP</button>
                            </form>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default AdminLogin;